import React from "react";
import PropTypes from "prop-types";
import { remapAddons } from "./helpers";
import CheckboxField from "wonderbly-components/lib/CheckboxField";
import isEmpty from "lodash/isEmpty";
import logger from "src/logger";

import "./UpsellItems.scss";

const UpsellItems = (props) => {
  if (isEmpty(props.availableAddons)) {
    return null;
  }
  try {
    const addons = remapAddons(props);
    const selectedAddonIndex = addons.findIndex(
      (addon) => addon.defaultChecked
    );
    const currentAddon =
      addons[selectedAddonIndex > -1 ? selectedAddonIndex : 0];

    return (
      <div className="UpsellItems">
        <CheckboxField {...currentAddon} />
      </div>
    );
  } catch (error) {
    logger.error(`Error loading upsell items: ${error}`);
    return null;
  }
};

UpsellItems.defaultProps = {
  availableAddons: [],
};

UpsellItems.propTypes = {
  handleEditAddon: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  countryModel: PropTypes.object,
  availableAddons: PropTypes.array,
};

export default UpsellItems;
